import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import RecruitmentLandingView from '@/website/components/NewLandingPages/recruitment/index';
import { getRequestLanguage } from '@/website/constants/locales';
import { useRecruitmentBodySchemeMarkup } from '@/website/hooks/seo/useRecruitmentBodySchemeMarkup';
import Layout from '@/website/layouts/newLandingPages';
import { ContentfulPageProps, getContentfulData } from '@/website/lib/getContentfulData';
import { buildCanonicalUrl } from '@/website/util/canonical';
import { getRecruitmentWebsiteCrawlerHeadData } from '@/website/util/crawler';
import { PROVIDER_SOURCE } from '@jove-frontend/uikit';
import { Box } from '@mui/material';

const SLUG = 'recruitment';
export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<ContentfulPageProps>> {
  const language = getRequestLanguage(context.locale, context.req.headers.cookie);

  return getContentfulData(context, SLUG, {
    providerCode: PROVIDER_SOURCE().RECRUITMENT.value,
    metaInfo: {
      title: getRecruitmentWebsiteCrawlerHeadData(language)?.title,
      description: getRecruitmentWebsiteCrawlerHeadData(language)?.description,
      images: '/recruitment-landing.png',
    },
    useNewLogic: true,
    dataFileName: 'recruitment-landing-data.json',
    activeLanguage: language,
  });
}

const RecruitmentLandingPage = (props: ContentfulPageProps) => {
  const { post, promotion, metadata } = props;
  const router = useRouter();
  const { loadScript } = useRecruitmentBodySchemeMarkup();

  return (
    <>
      <Head>
        <title>{metadata?.openGraph?.title}</title>
        <meta name="description" content={metadata?.openGraph?.description} />
        <link
          key="canonical"
          rel="canonical"
          href={buildCanonicalUrl(router.asPath, process.env['NX_WEBSITE_URL'], router.locale, router.query.country as string)}
        />
        <meta content={metadata?.openGraph?.title} property="og:title" key="og-title" />
        <meta content={metadata?.openGraph?.description} property="og:description" key="og-description" />
        <meta name="twitter:title" content={metadata?.openGraph?.title} />
        <meta name="twitter:description" content={metadata?.openGraph?.description} />
      </Head>
      <Layout.Wrapper>
        <Layout.Header customLogoUrl={promotion?.brandingLogo} promotion={promotion} />
        <Layout.Content>
          <Box className="flex w-full flex-col space-y-16 bg-[#EBEFFE]">
            <RecruitmentLandingView useNewLogic info={post} />
          </Box>
        </Layout.Content>
        <Layout.Footer />
      </Layout.Wrapper>
    </>
  );
};

export default RecruitmentLandingPage;
